import React, { useState, useEffect } from 'react';
import styles from './Input.module.scss';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const Input = ({ uppercase, max, onChange, className, ...props }) => {
  const [data, setData] = useState('');

  useEffect(() => {
    if (onChange) {
      onChange(data);
    }
  }, [data, onChange]);

  return (
    <div className={styles.container}>
      <input
        className={classNames(
          styles.input,
          {
            [styles.uppercase]: uppercase === true,
          },
          className
        )}
        onChange={(e) => {
          const value = e.target.value;
          if (max && value.length > max) {
            setData(value.substring(0, max));
          } else {
            setData(value);
          }
        }}
        value={data}
        {...props}
      />
    </div>
  );
};

Input.propTypes = {
  uppercase: PropTypes.bool,
  max: PropTypes.number,
  onChange: PropTypes.func,
  className: PropTypes.string,
};

Input.defaultProps = {
  uppercase: false,
  max: false,
  onChange: null,
  className: null,
};

export default Input;
